import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { injectIntl } from 'react-intl'
import { reduxForm, initialize, destroy, propTypes } from 'redux-form'
import { CheckboxField } from 'components/forms'
import { FormattedMessage } from 'react-intl'
import { Button, SvgSpriteSheet } from 'components/util'

import styles from 'components/deletion/_deletion.css'

export const FORM_NAME = 'secondaryVerifyPassword'

const validate = (values) => {
  const errors = {}
  if (!values.agreement1) { errors.agreement1 = 'required' }
  if (!values.agreement2) { errors.agreement2 = 'required' }
  if (!values.agreement3) { errors.agreement3 = 'required' }
  return errors
}

const formOptions = {
  form: FORM_NAME,
  validate,
}

const mapStateToProps = () => {
  return {
  }
}

const mapDispatchToActions = {
  initialize,
  destroy,
}

export class DeletionSecondaryForm extends Component {
  static propTypes = {
    ...propTypes,
    intl: PropTypes.object,
    initialize: PropTypes.func,
    handleSubmit: PropTypes.func,
    error: PropTypes.string,
    disabled: PropTypes.bool,
  }

  render () {
    const { handleSubmit, invalid, pristine } = this.props

    return (
      <form method='post' onSubmit={handleSubmit} className={styles.deleteVerifyForm}>
        <h3 className={styles.deleteVerifyTitle}>
          <FormattedMessage
            id='auth.password.verfiy.secondaryTitle'
            defaultMessage={`
              Warning: This cannot be undone and your information cannot be recovered
            `}
          />
        </h3>
        <CheckboxField
          bold
          name='agreement1'
          value='agreement1'
          className={styles.agreement1}
          onChange={this.handleAgreement1}
          labelComponent={<FormattedMessage
            id='delete.password.secondary.verify.note'
            defaultMessage={`
              Yes, permanently delete my Under Armour account and remove me from
              MapMyFitness (including MapMyRun, MapMyRide, MapMyHike, and MapMyWalk) and UA Record
            `}
          />}
        />

        <CheckboxField
          bold
          name='agreement2'
          value='agreement2'
          className={styles.agreement2}
          onChange={this.handleAgreement2}
          labelComponent={<FormattedMessage
            id='delete.password.secondary.verify.note2'
            defaultMessage={`
              Yes, I understand I will permanently lose access to the data
              associated with my profile, including workouts, notes, sleep sessions,
              Simple Nutrition logs, feed posts, and any photos or videos attached to posts.
            `}
          />}
        />

        <CheckboxField
          bold
          name='agreement3'
          value='agreement3'
          className={styles.agreement3}
          onChange={this.handleAgreement3}
          labelComponent={<FormattedMessage
            id='delete.password.secondary.verify.note3'
            defaultMessage={`
              Yes, I understand this action cannot be undone.
            `}
          />}
        />

        <Button
          el='button'
          type='warning'
          disabled={invalid || pristine}
          className={styles.button}
        >
          <FormattedMessage
            id='delete.password.secondary.verify.btn.delete'
            defaultMessage={`
              Delete Account
            `}
          />
        </Button>
        <SvgSpriteSheet />
      </form>
    )
  }

}

export const Form = reduxForm(formOptions)(DeletionSecondaryForm)

export const IntlForm = injectIntl(Form)
export default connect(mapStateToProps, mapDispatchToActions, null, { withRef: true })(IntlForm)



// WEBPACK FOOTER //
// ./src/components/deletion/SecondaryVerification.jsx